import ExpandableSection from "../component/_expandableSection";

document.addEventListener('DOMContentLoaded', function () {
    const industrySections = document.querySelectorAll('.js-section-industry-specification-block__item');

    industrySections.forEach((accordion) => {
        new ExpandableSection(
            '.js-section-industry-specification-block__item',
            '.js-section-industry-specification-block-question-wrapper',
            '.js-section-industry-specification-block__industry-description',
            '.js-section-industry-specification-block__chevron',
            false,
            true,
            false,
            true
        );
    });

    const updateImageHeight = () => {
        const bgElement = document.querySelector('.js-section-industry-specification-block__bg');
        const imageElement = document.querySelector('.js-section-industry-specification-block__block__image');

        if (bgElement && imageElement) {
            const bgHeight = bgElement.offsetHeight;
            imageElement.style.maxHeight = `${bgHeight}px`;
        }
    };

    updateImageHeight();

    window.addEventListener('resize', () => {
        updateImageHeight();
    });
});
